import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { RealisationHourtype } from 'src/app/classes/realisation';

interface WeekScheduleDayItem {
    begindate: Date;
    enddate: Date;
    dayOff?: boolean;
}

@Component({
    selector: 'app-week-schedule-day',
    templateUrl: './week-schedule-day.component.html',
    styleUrl: './week-schedule-day.component.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class WeekScheduleDayComponent {
    @Input() item: WeekScheduleDayItem;
    @Input() previousItem?: WeekScheduleDayItem;
    @Input() nextItem?: WeekScheduleDayItem;
    @Input() maxDate: Date;
    @Input() leaveHourtype?: RealisationHourtype;
    @Input() leaveComment?: string;

    @Output() openItem = new EventEmitter<void>();
}
